import script from "./collegeWorld.vue?vue&type=script&setup=true&lang=js"
export * from "./collegeWorld.vue?vue&type=script&setup=true&lang=js"

import "./collegeWorld.vue?vue&type=style&index=0&id=709dabc1&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709dabc1"]])

export default __exports__